export default __webpack_public_path__ + "static/media/microsoft.e116a418.svg";